import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const DifficultRate = () => {
  return (
    <HomeUI />
  )
}

export default DifficultRate
